import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isLoggedIn, isServiceProvider } from "../../utils/AuthService";
import Header from "../../components/layouts/Header";
import Footer from "../../components/layouts/Footer";
import Sidebar from "./Sidebar";

const MarketLayout = () => {
  if (!isLoggedIn()) {
    return <Navigate to="/login" />;
  }

  // Service providers should only access the provider portal
  if (isServiceProvider()) {
    return <Navigate to="/provider-portal" />;
  }

  return (
    <div className="app">
      <Header />
      <div className="app-body">
        <Sidebar />
        <main className="main">
          <div className="container-fluid mt-2">
            <Outlet />
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default MarketLayout;
